import React, { useState, useEffect, useRef, useContext } from "react";
// import { Link } from "react-router-dom";
import axios from "axios";
import "../programsdash/ProgramsDash.css";
import Menu from "../../components/menu/Menu";
import Patients from "../../components/patients/Patients";
import { Context } from "../../context/Context";

const PatientsList = (props) => {
  // const [selectedTab, setSelectedTab] = useState("Patients");
  const {patientsData, setPatientsData,contentPatientsLoaded, setContentPatientsLoaded} = useContext(Context);
  let selectedTab = "Patients";
  // const [patientsData, setPatientsData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [contentPatientsLoaded, setContentPatientsLoaded] = useState(true);
  const [search, setSearch] = useState("");
  const searchPatients = useRef("");
  const [isSorted, setSorted] = useState(true);
  const [notFoundError, setNotFoundError] = useState(false);

  useEffect(() => {
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, [])

  useEffect(() => {
    props.actSidebar(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      setLoading(true);
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/my-patients", {
          search,
          selectedTab,
        })
        .then((res) => {
          if (res.data.responseData) {
            setLoading(false);
            setNotFoundError(false);
            setPatientsData(res.data.responseData);
            setContentPatientsLoaded(true);
            localStorage.removeItem("imported_tasks");
            localStorage.removeItem("inserted_activities");
            localStorage.removeItem("deleted_activities");
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 417) {
            setNotFoundError(true);
            setLoading(false);
            setContentPatientsLoaded(true);
          }
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          }
        });
    }
    // eslint-disable-next-line
  }, [search, selectedTab]);

  const updateSearchQuery = (value) => {
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setPatientsData(sorted);
  };

  return (
    <div>
      <Menu title={"Patients"} />
      <div className="programs_dash_hold">
        {/* <div className="programs_dash_top_hold">
          <div className="programs_dash_top_options">
            <div className="programs_dash_contain_opts">
              <div
                className={"programs_dash_option" + (selectedTab === "Patients" ? " p_d_option_selected" : "")}
                onClick={() => setSelectedTab("Patients")}
              >
                Patients
              </div>
            </div>
          </div>
        </div> */}
        <div className="table_component_container" style={{paddingTop: '10px'}}>
        <Patients
          loading={loading}
          patientsData={patientsData}
          searchPatients={searchPatients}
          contentLoaded={contentPatientsLoaded}
          selectedTab={selectedTab}
          updateSearchQuery={updateSearchQuery}
          handleSorting={handleSorting}
          notFoundError={notFoundError}
        />
        </div>
      </div>
    </div>
  );
};

export default PatientsList;
